import JoinForm from '@component/joinForm';
import Account from '@component/account/Account';
import MobileVerify from '@component/mobile-verify';
import CheckLawfulFrame from '@component/check-lawful-frame';
import './HomePage.css';
import { useAppSelector } from '@store/hooks';
import { getIfShowAgreement, getIfShowMobileVerify } from '@store/ui/ui.slice';
import { isMobileBrowser } from '@utils/browser';

const Home = () => {
  const ifShowAgreement = useAppSelector(getIfShowAgreement);
  const ifShowMobileVerify = useAppSelector(getIfShowMobileVerify);

  const isPhone = isMobileBrowser();

  return (
    <div className={`${isPhone ? 'join-page-mobile' : 'join-page'}`}>
      <Account />
      {!ifShowMobileVerify && !ifShowAgreement && <JoinForm />}
      {
        // 手机号验证
        ifShowMobileVerify && !ifShowAgreement && <MobileVerify />
      }
      {
        // 合规
        ifShowAgreement && <CheckLawfulFrame />
      }
    </div>
  );
};

export default Home;
